/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export class ImageLoaderTypes {
    public static readonly DEFAULT = '';

    public static readonly POSTER_IMAGE = 'poster-image';

    public static readonly CHANNEL_BRANDING_IMAGE = 'channel-branding-image';

    public static readonly CHANNEL_LOGO_PREVIEW_ICON = 'channel-logo-preview-icon';

    public static readonly LEFT_ARROW_ICON = 'left-arrow-icon';

    public static readonly OPTION_BUTTON_ICON = 'option-button-icon';

    public static readonly OSD_BRANDING_ICON = 'osd-branding-icon';

    public static readonly OVERLAY_BRANDING_ICON = 'overlay-branding-icon';

    public static readonly SETTINGS_SCREEN_CHANNEL_BRANDING = 'settings-screen-channel-branding';

    public static readonly STANDARD_INFO_BANNER_PARTNER_BRANDING =
        'standard-info-banner-partner-branding';

    public static readonly STANDARD_INFO_BANNER_PARTNER_BRANDING_WITH_SOCU_ICON =
        'standard-info-banner-partner-branding-with-socu-icon';

    public static readonly STANDARD_INFO_BANNER_CHANNEL_BRANDING =
        'standard-info-banner-channel-branding';

    public static readonly PARTNER_IMAGE_PRIMARY_BRANDING = 'partner-image_primary_branding';

    public static readonly PROVIDER_IMAGE_PREVIEW_ICON = 'provider-image-preview-icon';

    public static readonly RIGHT_ARROW_ICON = 'right-arrow-icon';

    public static readonly SPLASH_SCREEN_PARTNER_BRANDING = 'splash-screen-partner-branding';

    public static readonly TEXT_VIEW_ICON = 'text-view-icon';

    public static readonly MEDIA_PAUSE_ICON = 'media-pause-icon';

    public static readonly MEDIA_HIGHLIGHTED_PAUSE_ICON = 'media-pause-icon highlighted';

    public static readonly SCREEN_HEADER_PRIMARY_BRANDING = 'screen-header-primary-branding';

    public static readonly RECORDING_PREVIEW_IMAGE = 'recording-preview-image';

    public static readonly GALLERY_EPISODE_VOD_ITEM = 'gallery-episode-vod-item';

    public static readonly GALLERY_MOVIE_VOD_ITEM = 'gallery-movie-vod-item';
}
